$('.promocod5000 .close').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('.promocod5000').fadeOut();
    $.cookie('promo5000', 'hide', {expires: 3, path: '/'})
});